import { Button, Typography } from '@material-ui/core'
import { signUp as amplifySignUp } from 'aws-amplify/auth'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import validator from 'validator'

import { SectionSubTitle } from '../../components/atoms/SectionTittle'
import { TextInputEx } from '../../components/atoms/TextInputEx'
import { containerStyles } from '../../styles/ContainerStyles'
import { showMessage } from '../../utils/notification'

export const SignUp: React.FC = () => {

    const [email, setEmail] = React.useState<string>('')
    const [password, setPassword] = React.useState<string>('')
    const [repeatPassword, setRepeatPassword] = React.useState<string>('')
    const [firstName, setFirstName] = React.useState<string>('')
    const [lastName, setLastName] = React.useState<string>('')

    const styles = containerStyles()

    const history = useHistory()

    const inputsAreValid = validator.isEmail(email) && password.length >= 6
        && password === repeatPassword
            && firstName.length >= 2 && lastName.length >= 3

    const signUp = async () => {
        if (!validator.isLength(password, {
            min: 8
        })) {
            showMessage('Kode skal være mindst 8 karakterer', 'error')
            return
        }

        try {
            await amplifySignUp({
                username: email,
                password,
                options: {
                    userAttributes: {
                        email,
                        'custom:firstName': firstName, 
                        'custom:lastName': lastName 
                    }
                }
            })

            // In v6, signUp always returns a result, so we can navigate directly
            history.push({
                pathname: '/bekraeftet',
                state: {
                    email, password, firstName, lastName
                }
            })
        } catch (error: any) {
            if (error.code === 'UsernameExistsException') {
                // eslint-disable-next-line max-len
                showMessage('Der eksisterer allerede en bruger med denne mail. Besøg "Log ind", derefter "Nulstil adgangskode".', 'error')
            } else {
                showMessage('Der opstod en fejl under tilmelding. Prøv igen.', 'error')
            }
        }
    }

    return (
        <div className={styles.authContainer}>
            <div className={styles.innerAuthContainer}>
                <SectionSubTitle text="Oprette Bruger"/>

                <div>
                    <TextInputEx
                        fullWidth
                        value={email}
                        onChange={setEmail}
                        label="Email" />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <TextInputEx
                            fullWidth
                            value={firstName}
                            onChange={setFirstName}
                            label="Fornavn"/>
                        <TextInputEx
                            fullWidth
                            value={lastName}
                            onChange={setLastName}
                            label="Efternavn"/>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <TextInputEx
                            fullWidth
                            value={password}
                            label="Password"
                            onChange={setPassword}
                            type="password"/>
                        <TextInputEx
                            fullWidth
                            value={repeatPassword}
                            onChange={setRepeatPassword}
                            label="Gentag Password"
                            type="password"/>
                    </div>
                    <Typography style={{ color: '#33949E' }} variant="body1">
                        Kode skal være mindst 8 karakterer
                    </Typography>
                </div>
                <div>
                    <Button
                        onClick={signUp}
                        className="btn-auth"
                        disabled={!inputsAreValid}>
                        Tilmeld dig nu
                    </Button>
                </div>
            </div>
        </div>
    )
}
